// @flow

import React, {type Node} from 'react';
import styled from 'styled-components';
import {getAllAllowedCryptocurrencyTypes} from '@tectonics/commons/cryptocurrency/cryptocurrencies/cryptocurrencies';
import {useOpenedIncomingPayment} from '@tectonics/prs/incoming-payment';

export function DisplayCryptocurrencyBrands(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  const cryptocurrencies = getAllAllowedCryptocurrencyTypes(incomingPayment);

  if (!cryptocurrencies.length) return null;

  return (
    <Root>
      {cryptocurrencies.map((cryptocurrency) => {
        return (
          <BrandImageWrapper key={cryptocurrency.code}>
            {cryptocurrency.icon}
          </BrandImageWrapper>
        );
      })}
    </Root>
  );
}

const Root = styled.div`
  height: 100%;
  display: flex;
`;

const BrandImageWrapper = styled.div`
  flex-grow: 1;
  padding-left: 4px;
`;
